import { ISuggestedFaqSourceChannel } from '@/models/suggestedFaq.model';
import { TApproveFaqFormValues } from './types';

export const getApproveFaqFormValues = (
  sourceChannels?: ISuggestedFaqSourceChannel[],
): Partial<TApproveFaqFormValues> => ({
  isGeneral: true,
  channelIds: sourceChannels?.map((channel) => channel.channelId) ?? [],
});
